var React = require('react');

function CloseBlack (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#000","d":"M16.2635 14.8492L29.6985 1.41421L28.2843 0L14.8492 13.435L1.41421 0L0 1.41421L13.435 14.8492L0 28.2843L1.41421 29.6985L14.8492 16.2635L28.2843 29.6985L29.6985 28.2843L16.2635 14.8492Z"}));
}

CloseBlack.defaultProps = {"width":"30","height":"30","viewBox":"0 0 30 30","fill":"none"};

module.exports = CloseBlack;

CloseBlack.default = CloseBlack;
